import {
  FlashOn,
  LocalShipping,
  LocationOn,
  Security,
  ShoppingCart,
  Star,
  WifiProtectedSetup,
} from "@mui/icons-material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useStateValue } from "../StateProvider";
import "./SingleProducts.css";
import SingleSmallImg from "./SingleSmallImg";

function SingleProduct() {
  const unavailable = "https://www.movienewz.com/img/films/poster-holder.jpg";
  const [single, setSingle] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const { pramsId } = useParams();
  const [addCart, setAddCart] = useState(false);
  const [state, dispatch] = useStateValue();
  const addToBasket = () => {
    dispatch({
      type: "Add_To_Cart",
      item: {
        id: single?.id,
        title: single?.title,
        brand: single?.brand,
        description: single?.description,
        images: single?.images,
        thumbnail: single?.thumbnail,
        rating: single?.rating,
        stock: single?.stock,
        price: single?.price,
      },
    });
  };

  const fetchSingleData = async () => {
    const { data } = await axios.get(
      `https://dummyjson.com/products/${pramsId}`
    );
    console.log(data);
    console.log(inputValue)
    setSingle(data);
  };
  useEffect(() => {
    fetchSingleData();
  }, []);
  const originalPrice =
    (single?.price + (single?.price * single?.discountPercentage) / 100) * 80;
  return (
    <div className="singleProducts">
      <div className="singleProducts_left">
        <div className="singleProducts_left_MainImg">
          <img src={single && single?.thumbnail} alt="" />
        </div>
        <div className="singleProducts_left_Img">
          {single &&
            single.images?.map((img) => (
              <SingleSmallImg img={img ? img : unavailable} />
            ))}
        </div>
        <div className="singleProducts_Button">
          <button className="addToCart" onClick={() => setAddCart(true),addToBasket}>
            <ShoppingCart /> {addCart ? "Go To Cart" : "Add To Cart"}
          </button>
          <button className="buyNow">
            <FlashOn /> Buy Now
          </button>
        </div>
      </div>
      <div className="singleProducts_right">
        <div className="singleProducts_right_Info">
          <h3>{single?.title}</h3>
          <div className="single_right_rating">
            <p className="single_right_rating_num">
              {single?.rating}
              <Star className="single_right_rating_num_Icon" />
            </p>
            <p className="single_right_rating_Review">
              <span>{Math.round(Math.random(Math.round() * 200) + 100)}</span>
              <span>Ratings</span>
              <span>&</span>
              <span>{Math.round(Math.random(Math.round() * 20) + 80)}</span>
              <span>Reviews</span>
            </p>
          </div>
          <span className="singleProducts_right_Price">
            <p className="singleProducts_right_Price_Special">Special price</p>
            <div className="zero">
              <div className="one">
                <p className="singleProducts_right_Price_price">
                  <span className="singleProducts_right_Price_price_span">
                    ₹{Math.round(single?.price * 80)}
                  </span>
                </p>
              </div>
              <div className="two">
                <s className="singleProducts_right_Price_price_s">
                  ₹{Math.round(originalPrice)}
                </s>
              </div>
              <div className="three">{single?.discountPercentage} off</div>
            </div>
          </span>
          <div className="singleProducts_right_delivery">
            <span>Delivery</span>
            <span className="singleProducts_right_delivery_span">
              <LocationOn style={{color:'#878787',fontSize:'15px'}}/>
              <input
                type="text"
                maxLength='6'
                placeholder="Enter Delivery Pincode"
                
                
              />
              <p style={{color:'#2874F0'}}>Check</p>
            </span>
          </div>
          <div className="singleProducts_right_Icon">
          <span>
            <LocalShipping className="singleProducts_right_Icon_Icon" />
            <p>Delivery</p>
          </span>
          <span>
            <Security className="singleProducts_right_Icon_Icon" />
            <p>1 Year Warrenty</p>
          </span>
          <span>
            <WifiProtectedSetup  className="singleProducts_right_Icon_Icon"/>
            <p>7days Return</p>
          </span>
        </div>
          <div className="description">
            <span>Description</span>
            <span className="description_api">{single?.description}</span>
          </div>
        </div>
       
      </div>
    </div>
  );
}

export default SingleProduct;
